export const LOGIN = '/login'
export const LOGOUT = '/logout'
export const DYNAMICS = ':dynamics'
export const NONDYNAMICS = ':nondynamics'
export const RESET_PWD = '/resetPassword'
export const RESET_PWD_EMAIL = '/resetPasswordEmail'
export const RESET_PWD_CONF = '/resetPasswordConfirmation'
export const ONE_TIME_PWD = '/otp'
export const QR_CODE = '/qrCode'
export const PARTNER_DASHBOARD = '/Dashboard'
export const PARTNER_DASHBOARD_V2 = '/dashboard-v2'
export const PARTNER_DASHBOARD_IM = '/insurance-impact-dashboard'
export const LEAK_INVESTIGATION_REPORTS = '/leak-investigation-reports'
export const DEMO_CHARTS = '/demoCharts'

// MAIN VIEWS
export const HOME = '/'
export const DASHBOARD = '/dashboard'
export const DEVICE_LIST = '/devicelist'
export const REPORTS = '/reports'
export const DEVICE_VIEW = '/deviceview/'
export const DEVICE_VIEW_ID = ':deviceID' // LbDevice_ID
export const DEVICE_VIEW_LBID = ':LbDevice_ID'
export const LEAK_LIST = '/leaklist'
export const SEARCH = '/search'
export const SEARCH_NON_DYNAMICS = '/search/:nondynamics'
export const EVENT_LIST = '/eventlist'
export const INCOMPLETE_INSTALLS = '/incompleteInstalls'
export const TENANTS_LIST = '/tenantsList'
export const TENANT_GROUPS = '/tenantGroups'
export const ASSIGN_TENANT = '/assigntenant'
export const MESSAGE_LIST = '/messagelist'
export const ROLES_API = '/rolesAPI'
export const USER_ROLE = ':role_ID'
export const ADD_API_2_ROLE = '/addApi2Role'
export const ADD_ROLE_2_API = '/addRole2Api'
export const USER_LIST = '/userlist'
export const UPDATE_PARAMETERS = '/updateParameters'
export const MATLAB_PARAMETERS_DICTIONARY = '/matlabParametersDictionary'
export const DEVICE_MATLAB_PARAMETERS = '/deviceMatlabParameters'
export const EVENTS_VIEW = '/eventsView/'
export const COMMS_VIEW = '/commsView/'
export const ORDERS_MANAGEMENT = '/ordersManagement/'
export const COMMS_VIEW_ALONE = '/commsViewAlone/'
export const PROFILE_VIEW = '/profileView/'
export const REMOVED_DEVICES = '/removedDevices'

// COMPONENTS
export const COMPONENTS = 'components'
export const CARDS = 'cards'
export const MODALS = 'modals'
export const TABLES = 'tables'

// PAGES
export const PAGES = '/pages'
export const PAGE_404 = '404'
